<template>
  <div class="vue-tempalte p-4">
    <form @submit.prevent="userLogin">
      <h3 class="text-center">ადმინ პანელში შესვლა</h3>

      <div class="form-group">
        <label>ელ. ფოსტა</label>
        <input
          type="email"
          class="form-control form-control-lg"
          v-model="user.email"
        />
      </div>

      <div class="form-group">
        <label>პაროლი</label>
        <input
          type="password"
          class="form-control form-control-lg"
          v-model="user.password"
        />
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block">
        შესვლა
      </button>

      <h3 class="forgot-password mb-4">
        <strong>
          <router-link
            to="/forgot-password"
            class="badge badge-pill badge-light pb-3"
          >
            დაგავიწყდათ პაროლი?</router-link
          >
        </strong>
      </h3>
    </form>
  </div>
</template>


<script>
import firebase from "firebase";

export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    userLogin() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then(() => {
          this.$router.push("/home");
          this.loginShow = false;
        })
        .catch((error) => {
          alert(error.message);
        });
    },
  },
};
</script>